import { defineChain } from 'viem';
/** Robinhood Chain mainnet. Confirmed live: `eth_chainId` returns 0x1237. */
export const ROBINHOOD_CHAIN_ID = 4663;
export const DEFAULT_RPC_URL = 'https://rpc.mainnet.chain.robinhood.com';
/**
 * The block explorer is not baked in: set `explorerUrl` in the deployment file
 * (or `VITE_EXPLORER_URL`) once the founder confirms it. Everything that would
 * render a link degrades to plain text while it is unset, rather than pointing
 * somewhere invented.
 */
export function robinhoodChain(rpcUrl = DEFAULT_RPC_URL, explorerUrl) {
    return defineChain({
        id: ROBINHOOD_CHAIN_ID,
        name: 'Robinhood Chain',
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpcUrls: { default: { http: [rpcUrl] } },
        ...(explorerUrl ? { blockExplorers: { default: { name: 'Explorer', url: explorerUrl } } } : {}),
    });
}
//# sourceMappingURL=chain.js.map